import ApiService from '@/core/api/api.service';

import { functionsWithNotifications } from '@/core/notifications';
import oneTimePassMessages from './one-time-pass.messages';
import OneTimePass from './one-time-pass.mapper';

const functions = {
  get,
};

export default {
  ...functionsWithNotifications(functions, oneTimePassMessages),
};

const oneTimePassApi = new ApiService();

async function get(clientUuid, locationUuid) {
  const requestConfig = {
    params: {
      location_uuid: locationUuid,
    },
  };

  const response = await oneTimePassApi.get(`vendors/${clientUuid}/one_time_passes`, requestConfig);
  // Although the API returns an array, a location can only ever have a maximum of one one time pass
  const pass = _.get(response, 'data.data[0]');
  if (!pass) {
    throw new Error();
  }
  return new OneTimePass(pass);
}
